import React, { useState, useEffect, useRef } from "react"
import { IPatient } from "../../../../core/services/models/Patient"
import {
  saveNutritionistAssessment,
  saveNutritionScreeningNotes, saveNutritionFollowUp,
  getNutritionistDetails
} from "../../../../core/services/api/patientClinicalService"
import SummaryView from "../../../../components/SummaryView"
import JSONRenderer from "../../../../components/JSONRenderer/JSONRenderer"
import Toast from "../../../../components/Toast"
import "./Nutritionist.scss"
import { useSelector } from "react-redux"
import { MocUserRole } from "../../../../core/services/models/Enums"
import moment from "moment"
import { getManageStaffDetailsById } from "core/services/api"
import { getTemplatesByType, getVitals } from "core/services/api/patientDiagnosisService"
import AddDietPlan from "./AddDietPlan"
import Print from "components/Print/Print"

const Nutritionist: React.FunctionComponent<any> = (
  {
    patientInfo,
    recordDetails,
    appointmentDetails,
    isReadOnly,
    staffType,
    smartSummaryDetails,
    fetchSmartSummary
  }
) => {

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const componentRef = useRef()
  const tabSection: string[] = [
    "Smart Summary",
    "Assessment 1",
    "Assessment 2",
    "Diet Plan",
    "Follow Up",
  ]

  const [patientDetail, updatePatientDetail] = React.useState<IPatient>(
    patientInfo
  )
  const [selectedTab, setSelectedTab] = useState("Smart Summary")
  const [assessmentData, setAssessmentData] = useState({})
  const [screeningNotes, setScreeningNotes] = useState({})
  const [dietPlanDetails, setDietPlanDetails] = useState({})
  const [followUpData, setFollowUpData] = useState({})

  const [nutritionalAssessment, setNutritionalAssessment] = useState<any>({})
  const [nutritionalScreening, setNutritionalScreening] = useState<any>({})
  const [nutritionalAssessmentScreeningPrint, setNutritionalAssessmentScreeningPrint] = useState<any>({})
  const [nutritionalDietPlan, setNutritionalDietPlan] = useState<any>({})
  const [nutritionalDietPlanPrint, setNutritionalDietPlanPrint] = useState<any>({})
  const [nutritionalFollowUp, setNutritionalFollowUp] = useState<any>({})
  const [nutritionalFollowUpPrint, setNutritionalFollowUpPrint] = useState<any>({})
  const [isAssessmentCompleted, setIsAssessmentCompleted] = useState<any>(false)
  const [isScreeningCompleted, setIsScreeningCompleted] = useState<any>(false)
  const [isDietPlanCompleted, setIsDietPlanCompleted] = useState<any>(false)
  const [isFollowUPCompleted, setIsFollowUPCompleted] = useState<any>(false)
  const [staffDetails, setStaffDetails] = useState<any>()
  const [vitalsData, setVitalsData] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    let tempAssessmentJson: any = {}
    let tempScreeningJson: any = {}
    let tempAssessmentScreeningPrintJson: any = {}
    let tempDietJson: any = {}
    let tempDietPrintJson: any = {}
    let tempFPJson: any = {}
    let tempFPPrintJson: any = {}

    getTemplatesByType("NUTRITIONIST")
      .then((res: any) => {
        console.log(res, "nut")
        tempAssessmentJson = res?.find((e: any) => e?.subType === "Assessment")?.data[0]?.json || {}
        tempScreeningJson = res?.find((e: any) => e?.subType === "Screening")?.data[0]?.json || {}
        tempAssessmentScreeningPrintJson = res?.find((e: any) => e?.subType === "Assessment Screening Print")?.data[0]?.json || {}
        tempDietJson = res?.find((e: any) => e?.subType === "Diet Plan")?.data[0]?.json || {}
        tempDietPrintJson = res?.find((e: any) => e?.subType === "Diet Plan Print")?.data[0]?.json || {}
        tempFPJson = res?.find((e: any) => e?.subType === "Follow Up")?.data[0]?.json || {}
        tempFPPrintJson = res?.find((e: any) => e?.subType === "Follow Up Print")?.data[0]?.json || {}
        if (isReadOnly) {
          //Assessment
          tempAssessmentJson["pages"][0]["readOnly"] = true
          tempAssessmentJson["showNavigationButtons"] = "none"
          setNutritionalAssessment(tempAssessmentJson)
          //Screening
          tempScreeningJson["pages"][0]["readOnly"] = true
          tempScreeningJson["showNavigationButtons"] = "none"
          setNutritionalScreening(tempScreeningJson)
          //Assessment & Screening Print
          setNutritionalAssessmentScreeningPrint(tempAssessmentScreeningPrintJson)
          //Diet Plan
          // if (userRole !== MocUserRole?.NUTRITIONIST) {
          tempDietJson["pages"][0]["readOnly"] = true
          tempDietJson["showNavigationButtons"] = "none"
          // }
          setNutritionalDietPlan(tempDietJson)
          //Diet Plan Print
          setNutritionalDietPlanPrint(tempDietPrintJson)
          //Follow Up
          tempFPJson["pages"][0]["readOnly"] = true
          tempFPJson["showNavigationButtons"] = "none"
          setNutritionalFollowUp(tempFPJson)
          //Follow Up Print
          setNutritionalFollowUpPrint(tempFPPrintJson)
        } else {
          setNutritionalAssessment(tempAssessmentJson)
          setNutritionalScreening(tempScreeningJson)
          setNutritionalAssessmentScreeningPrint(tempAssessmentScreeningPrintJson)
          setNutritionalDietPlan(tempDietJson)
          setNutritionalDietPlanPrint(tempDietPrintJson)
          setNutritionalFollowUp(tempFPJson)
          setNutritionalFollowUpPrint(tempFPPrintJson)
        }
      })
      .catch((err: any) => console.log(err?.message))
  }, [isReadOnly])

  useEffect(() => {
    if (userDetail?.id) {
      getManageStaffDetailsById(userDetail?.id)
        .then((res: any) => {
          setStaffDetails(res)
        })
        .catch((err: any) => console.log(err?.message))
    }
    if (recordId) {
      getVitals(recordId)
        .then((res: any) => {
          setVitalsData(res?.data)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [])

  useEffect(() => {
    if (recordId) {
      // setIsLoading(true)
      getNutritionistDetails(recordId)
        .then((data: any) => {
          if (selectedTab === "Diet Plan") {
            const temp: any = { ...dietPlanDetails, ...data?.dietPlan }
            let tempDate = moment().format("YYYY-MM-DDTHH:MM")
            if (!temp["AnaesthetistName"]) {
              temp["AnaesthetistName"] = staffDetails?.name
            }
            if (!temp["Date"]) {
              temp["Date"] = tempDate
            }
            if (!temp["EmpNo"]) {
              temp["EmpNo"] = staffDetails?.mocConsultantId
            }
            if (!temp["dieticianSignature"]) {
              temp["dieticianSignature"] = staffDetails?.signaturePicUrl
            }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            setDietPlanDetails(temp)
          } else if (selectedTab === "Assessment 1") {
            const temp: any = { ...assessmentData, ...data?.assessment }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            if (!temp["Height"]) {
              temp["Height"] = vitalsData?.height
            }
            if (!temp["Weight"]) {
              temp["Weight"] = vitalsData?.weight
            }
            if (!temp["BMI"]) {
              temp["BMI"] = vitalsData?.bmi
            }
            handleValidateVitals(temp)
            setAssessmentData(temp)
          } else if (selectedTab === "Assessment 2") {
            const temp: any = { ...screeningNotes, ...data?.screening }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            setScreeningNotes(temp)
          } else if (selectedTab === "Follow Up") {
            const temp: any = { ...followUpData, ...data?.followUp }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            setFollowUpData(temp)
          }
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err)
          if (selectedTab === "Diet Plan") {
            const temp: any = { ...dietPlanDetails }
            let tempDate = moment(new Date()).format("YYYY-MM-DDTHH:mm")
            if (!temp["AnaesthetistName"]) {
              temp["AnaesthetistName"] = staffDetails?.name
            }
            if (!temp["Date"]) {
              temp["Date"] = tempDate
            }
            if (!temp["EmpNo"]) {
              temp["EmpNo"] = staffDetails?.mocConsultantId
            }
            if (!temp["dieticianSignature"]) {
              temp["dieticianSignature"] = staffDetails?.signaturePicUrl
            }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            setDietPlanDetails(temp)
          } else if (selectedTab === "Assessment 1") {
            const temp: any = { ...assessmentData }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            if (!temp["Height"]) {
              temp["Height"] = vitalsData?.height
            }
            if (!temp["Weight"]) {
              temp["Weight"] = vitalsData?.weight
            }
            if (!temp["BMI"]) {
              temp["BMI"] = vitalsData?.bmi
            }
            setAssessmentData(temp)
          } else if (selectedTab === "Assessment 2") {
            const temp: any = { ...screeningNotes }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            setScreeningNotes(temp)
          } else if (selectedTab === "Follow Up") {
            const temp: any = { ...followUpData }
            if (!temp["todaysDate"]) {
              temp["todaysDate"] = moment().format("YYYY-MM-DD")
            }
            setFollowUpData(temp)
          }
          setIsLoading(false)
        })
    }
  }, [selectedTab])

  useEffect(() => {
    const completeBtn = document.getElementById("sv-nav-complete")
    if (isReadOnly && completeBtn) {
      completeBtn.style.display = "none"
    }
  })

  const handleNutritionistAssessmentCompletion = (data: any) => {
    // setIsLoading(true)
    saveNutritionistAssessment(
      data,
      {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }
    )
      .then((res: any) => {
        setIsLoading(false)
        setIsAssessmentCompleted(true)
        setAssessmentData(res?.assessment)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleNutritionistScreeningCompletion = (data: any) => {
    // setIsLoading(true)
    saveNutritionScreeningNotes(
      data,
      {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }
    )
      .then((res: any) => {
        setIsLoading(false)
        setIsScreeningCompleted(true)
        setScreeningNotes(res?.screening)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  const handleNutritionistFollowUpCompletion = (data: any) => {
    // setIsLoading(true)
    saveNutritionFollowUp(
      data,
      {
        centerId,
        consultantId,
        patientId,
        appointmentId,
        recordId,
      }
    )
      .then((res: any) => {
        setIsLoading(false)
        setIsFollowUPCompleted(true)
        setFollowUpData(res?.followUp)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  function handleValidateVitals(data: any) {
    if (data) {
      if (Object.keys(data)?.length > 0) {
        Object.keys(data)?.forEach((v: any) => {
          if (v === 'AlbuminValues') {
            if (data?.AlbuminValues !== "" && (Number(data?.AlbuminValues) < 3.5 || Number(data?.AlbuminValues) > 5)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (3.5-5)"
              var element: any = document.querySelector('[data-key="AlbuminValues-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === "HemoglobinValue") {
            const lowerLimit = patientInfo?.gender?.toLowerCase() === "male" ? 13 : 11.5
            const upperLimit = patientInfo?.gender?.toLowerCase() === "male" ? 18 : 16.5
            if (data?.HemoglobinValue !== "" && (Number(data?.HemoglobinValue) < lowerLimit || Number(data?.HemoglobinValue) > upperLimit)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = `Value exceeds the range (${lowerLimit}-${upperLimit})`
              var element: any = document.querySelector('[data-key="HemoglobinValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'HGTValue') {
            if (data?.HGTValue !== "" && (Number(data?.HGTValue) < 70 || Number(data?.HGTValue) > 140)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (70-140)"
              var element: any = document.querySelector('[data-key="HGTValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'WBCValue') {
            if (data?.WBCValue !== "" && (Number(data?.WBCValue) < 4500 || Number(data?.WBCValue) > 11000)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (4500-11000)"
              var element: any = document.querySelector('[data-key="WBCValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'NeutrophilsValue') {
            if (data?.NeutrophilsValue !== "" && (Number(data?.NeutrophilsValue) < 2500 || Number(data?.NeutrophilsValue) > 7000)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (2500-7000)"
              var element: any = document.querySelector('[data-key="NeutrophilsValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'LympocytesValue') {
            if (data?.LympocytesValue !== "" && (Number(data?.LympocytesValue) < 1000 || Number(data?.LympocytesValue) > 4800)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (1000-4800)"
              var element: any = document.querySelector('[data-key="LympocytesValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'TotalProteinValue') {
            if (data?.TotalProteinValue !== "" && (Number(data?.TotalProteinValue) < 6 || Number(data?.TotalProteinValue) > 8)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (6-8)"
              var element: any = document.querySelector('[data-key="TotalProteinValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'SGPTValue') {
            if (data?.SGPTValue !== "" && (Number(data?.SGPTValue) < 5 || Number(data?.SGPTValue) > 35)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (5-35)"
              var element: any = document.querySelector('[data-key="SGPTValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'SGOTValue') {
            if (data?.SGOTValue !== "" && (Number(data?.SGOTValue) < 5 || Number(data?.SGOTValue) > 40)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (5-40)"
              var element: any = document.querySelector('[data-key="SGOTValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'SodiumValue') {
            if (data?.SodiumValue !== "" && (Number(data?.SodiumValue) < 130 || Number(data?.SodiumValue) > 145)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (130-145)"
              var element: any = document.querySelector('[data-key="SodiumValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'PotassiumValue') {
            if (data?.PotassiumValue !== "" && (Number(data?.PotassiumValue) < 3.5 || Number(data?.PotassiumValue) > 5)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (3.5-5)"
              var element: any = document.querySelector('[data-key="PotassiumValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'SCreatinineValue') {
            if (data?.SCreatinineValue !== "" && (Number(data?.SCreatinineValue) < 0.5 || Number(data?.SCreatinineValue) > 1.2)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (0.5-1.2)"
              var element: any = document.querySelector('[data-key="SCreatinineValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          } else if (v === 'totalBilirubinValue') {
            if (data?.totalBilirubinValue !== "" && (Number(data?.totalBilirubinValue) < 0.1 || Number(data?.totalBilirubinValue) > 1.2)) {
              const errorElement = document.createElement("div");
              errorElement.className = "survey-error";
              errorElement.innerHTML = "Value exceeds the range (0.1-1.2)"
              var element: any = document.querySelector('[data-key="totalBilirubinValue-1"]');
              if (element) {
                var childElement: any = element?.getElementsByClassName('survey-error')
                if (childElement?.length < 1) {
                  element.appendChild(errorElement);
                }
              }
            }
          }
        })
      }
    }
  }

  console.log("compo", componentRef.current)

  return (
    <div className="nutritionist-page-container">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="patient-diagnosis">
        <div className="patient-smart-summary">
          <div className="tab-wrapper">
            {tabSection.map((tabname) => (
              <div
                className={`tab ${selectedTab === tabname ? "active" : ""}`}
                onClick={() => {
                  setSelectedTab(tabname)
                  if (tabname === "Smart Summary") {
                    fetchSmartSummary()
                  }
                }}
              >
                {tabname}
              </div>
            ))}
          </div>
          <div className="content-wrapper">
            {selectedTab === "Smart Summary" ? (
              <SummaryView
                patientDetail={patientInfo}
                smartSummaryDetails={smartSummaryDetails}
              />
            ) : selectedTab === "Assessment 1" ? (
              <div>
                <span
                  className="print-button cursor-pointer"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Print
                    componentRef={componentRef}
                    documentTitle={`Assessment 1 ${patientInfo.mocId} ${patientInfo.name}`}
                  />
                </span>
                <JSONRenderer
                  json={nutritionalAssessment}
                  appointmentDate={appointmentDetails?.scheduleDate}
                  printJson={nutritionalAssessmentScreeningPrint}
                  data={assessmentData}
                  printData={{ ...assessmentData, ...screeningNotes, dieticianSignature: staffDetails?.signaturePicUrl }}
                  printRef={componentRef}
                  patientData={{ patientInfo: patientInfo, vitalsData: vitalsData }}
                  showPatientDetails={true}
                  handleCompletion={handleNutritionistAssessmentCompletion}
                  origin={MocUserRole.NUTRITIONIST}
                  smartSummaryData={smartSummaryDetails}
                />
              </div>
            ) : selectedTab === "Assessment 2" ? (
              <div className="screening-content">
                <div>
                  <span
                    className="print-button cursor-pointer"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Print
                      componentRef={componentRef}
                      documentTitle={`Assessment 2 ${patientInfo.mocId} ${patientInfo.name}`}
                    />
                  </span>
                  <JSONRenderer
                    json={nutritionalScreening}
                    appointmentDate={appointmentDetails?.scheduleDate}
                    printJson={nutritionalAssessmentScreeningPrint}
                    data={screeningNotes}
                    printData={{ ...assessmentData, ...screeningNotes, dieticianSignature: staffDetails?.signaturePicUrl }}
                    printRef={componentRef}
                    patientData={{ patientInfo: patientInfo, vitalsData: vitalsData }}
                    showPatientDetails={true}
                    handleCompletion={handleNutritionistScreeningCompletion}
                    origin={MocUserRole.NUTRITIONIST}
                    smartSummaryData={smartSummaryDetails}
                  />
                </div>
              </div>
            ) : selectedTab === "Diet Plan" ? (
              <div>
                <span
                  className="print-button cursor-pointer"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Print
                    componentRef={componentRef}
                    documentTitle={`Diet Plan ${patientInfo.mocId} ${patientInfo.name}`}
                  />
                </span>
                <AddDietPlan
                  appointmentDetails={appointmentDetails}
                  recordDetails={recordDetails}
                  patientInfo={patientInfo}
                  isReadOnly={isReadOnly}
                  vitalsData={vitalsData}
                  componentRef={componentRef}
                  smartSummaryData={smartSummaryDetails}
                />
              </div>
            ) : selectedTab === "Follow Up" ? (
              <div>
                <span
                  className="print-button cursor-pointer"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Print
                    componentRef={componentRef}
                    documentTitle={`Follow Up ${patientInfo.mocId} ${patientInfo.name}`}
                  />
                </span>
                <JSONRenderer
                  printRef={componentRef}
                  json={nutritionalFollowUp}
                  appointmentDate={appointmentDetails?.scheduleDate}
                  printJson={nutritionalFollowUpPrint}
                  data={followUpData}
                  printData={followUpData}
                  patientData={{ patientInfo: patientInfo, vitalsData: vitalsData }}
                  showPatientDetails={true}
                  handleCompletion={handleNutritionistFollowUpCompletion}
                  origin={MocUserRole.NUTRITIONIST}
                  smartSummaryData={smartSummaryDetails}
                />
              </div>

            ) : null}
          </div>
        </div>
        {
          isAssessmentCompleted ? (
            <Toast
              textMessage="Assessment data saved successfully"
              onCloseText={"Close"}
              onClose={() => {
                setIsAssessmentCompleted(false)
                const temp = { ...nutritionalAssessment }
                setNutritionalAssessment({})
                setTimeout(() => {
                  setNutritionalAssessment(temp)
                  handleValidateVitals(assessmentData)
                }, 0)
              }}
              type="success"
            ></Toast>
          ) : isScreeningCompleted ? (
            <Toast
              textMessage="Screening data saved successfully"
              onCloseText={"Close"}
              onClose={() => {
                setIsScreeningCompleted(false)
                const temp = { ...nutritionalScreening }
                setNutritionalScreening({})
                setTimeout(() => {
                  setNutritionalScreening(temp)
                }, 0)
              }}
              type="success"
            ></Toast>
          ) : isDietPlanCompleted ? (
            <Toast
              textMessage="Diet plan data saved successfully"
              onCloseText={"Close"}
              onClose={() => {
                setIsDietPlanCompleted(false)
                const temp = { ...nutritionalDietPlan }
                setNutritionalDietPlan({})
                setTimeout(() => {
                  setNutritionalDietPlan(temp)
                }, 0)
              }}
              type="success"
            ></Toast>
          ) : isFollowUPCompleted ? (
            <Toast
              textMessage="Follow up data saved successfully"
              onCloseText={"Close"}
              onClose={() => {
                setIsFollowUPCompleted(false)
                const temp = { ...nutritionalFollowUp }
                setNutritionalFollowUp({})
                setTimeout(() => {
                  setNutritionalFollowUp(temp)
                }, 0)
              }}
              type="success"
            ></Toast>
          ) : (
            ""
          )
        }
      </div>
    </div>
  )
}

export default Nutritionist
